import React from 'react';
import { LayersIcon } from 'lucide-react';
import { volumes } from '../data/content';
import { toneAt } from '../utils/iconTones';
import { Accent, SectionHeading } from './SectionHeading';
export function VolumesSection() {
  return <section className="w-full bg-cream-100 px-6 pb-10 pt-2 sm:pb-12" aria-labelledby="volumes-title" data-id="element-180" data-mp="cnzc7aepupau">
      <div className="mx-auto max-w-5xl" data-id="element-181" data-mp="7pxwmzgi1844">
        <SectionHeading id="volumes-title" badge="The 6 Volumes of the System" badgeIcon={LayersIcon} title={<>
              The Entire Architecture in <Accent data-id="element-183" data-mp="3purayudlj8xs">One Single Product</Accent>
            </>} subtitle="6 digital volumes with guides, protocols, and solved cases, ready for classroom implementation." data-id="element-182" data-mp="3g4ybgrqqak9w" />

        <ol className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-184" data-mp="2xegmmy90o8tt">
          {volumes.map(({
          icon: Icon,
          number,
          title,
          description
        }, index) => <li key={number} className="flex h-full flex-col rounded-xl border border-cream-300/60 bg-white p-5 transition-[border-color,box-shadow] duration-150 ease-out hover:border-ember-400 hover:shadow-card" data-id="element-185" data-mp="2sf3y892hytp4" data-mpi={index}>
              <h3 className="flex items-center gap-3" data-id="element-186" data-mp="2j4s5q6c2virt">
                <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${toneAt(index).bg}`} data-id="element-187" data-mp="2j7enszwlhgoa">
                  <Icon className={`h-[1.25rem] w-[1.25rem] ${toneAt(index).fg}`} strokeWidth={2} aria-hidden="true" data-id="element-188" data-mp="1qih3kr8tp9sw" />
                </span>
                <span className="min-w-0" data-id="element-189" data-mp="20h6nepka54bs">
                  <span className={`block font-display text-[0.7rem] font-bold uppercase tracking-[0.2em] ${toneAt(index).fg}`} data-id="element-190" data-mp="24hgu64fwbyrp">
                    Vol {number}
                  </span>
                  <span className="block text-[0.95rem] font-semibold leading-snug text-forest-900" data-id="element-191" data-mp="1gqkkh4ow8wo9">
                    {title}
                  </span>
                </span>
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-forest-600/90" data-id="element-192" data-mp="1prio3lvf726b">{description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}